import { render, staticRenderFns } from "./PointRankingSmallText.vue?vue&type=template&id=e3121280&scoped=true&"
import script from "./PointRankingSmallText.vue?vue&type=script&lang=js&"
export * from "./PointRankingSmallText.vue?vue&type=script&lang=js&"
import style0 from "./PointRankingSmallText.vue?vue&type=style&index=0&id=e3121280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3121280",
  null
  
)

export default component.exports